import VideoArtPage from './VideoArt'

export default VideoArtPage
